// d88a0b5e33a0fc9e3ecff4452e7a717a9acf33cd|kind=parser-js|name=ChatConfigResponse|schemaHash=3acc34086da4b7b06bb80c5e57b449001362d514

import { setDefinedValue } from '@myre/common-primitives';

import { parseAgentFromJSON, parseAgentToJSON } from './Agent';
import { parseChatFooterFromJSON, parseChatFooterToJSON } from './ChatFooter';

export function parseChatConfigResponseFromJSON(
  _data,
) {
  if (!_data) {
    return _data;
  }

  const result = {};

  setDefinedValue(
    result,
    'footer',
    parseChatFooterFromJSON(
      _data.footer
    ),
  );
  setDefinedValue(
    result,
    'agents',
    Array.isArray(_data.agents)
      ? _data.agents.map(item =>
          parseAgentFromJSON(item),
        )
      : _data.agents,
  );
  setDefinedValue(result, 'greetingMessage', _data.greetingMessage);

  return result;
}

export function parseChatConfigResponseToJSON(
  _data,
) {
  if (!_data) {
    return _data;
  }

  const result = {};

  setDefinedValue(
    result,
    'footer',
    parseChatFooterToJSON(
      _data.footer
    ),
  );
  setDefinedValue(
    result,
    'agents',
    Array.isArray(_data.agents)
      ? _data.agents.map(item =>
          parseAgentToJSON(item),
        )
      : _data.agents,
  );
  setDefinedValue(result, 'greetingMessage', _data.greetingMessage);

  return result;
}
